<template>
  <swiper :options="swiperOption" id="comswiper" ref="mySwiper">
    <swiper-slide v-for="slide in resbanner" class="swiperBox" :key="slide">
      <img
        :src="slide.img"
        :alt="slide.title"
        class="middle"
        @click="routeTo(slide.link)"
      />
      <h2 class="title">{{ slide.title }}</h2>
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
</template>

<script>
export default {
  name: "carrousel",
  data() {
    return {
      swiperOption: {
        autoplay: true, //可选选项，自动滑动
        //          loop: true,
        effect: "fade",
        fadeEffect: {
          crossFade: true
        },
        initialSlide: 0,
        autoHeight: true,
        speed: 1000,
        grabCursor: true,
        observeParents: true,
        updateOnImagesReady: true,
        notNextTick: true,
        pagination: {
          el: ".swiper-pagination"
        },
        on: {
          imagesReady: function() {},
          slideChangeTransitionStart: function() {}
        }
      }
    };
  },
  props: ["resbanner"],
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    this.swiper.slideTo(0, 3000, "");
  },
  methods: {
    routeTo(url) {
      this.$router.push(url);
    }
  }
};
</script>
<style lang="less">
#comswiper {
  height: inherit;
  overflow: hidden;
  .swiperBox {
    postion: relative;
    height: inherit;
    img {
      margin: 0 auto;
      height: inherit;
      position: absolute;
    }
    .title {
      position: absolute;
      bottom: 20px;
      font-size: 20px;
      color: white;
      text-align: center;
      margin: 0 auto;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/comswiper.vue